webpackJsonp([2],{

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/


(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pariplay", [], factory);
	else if(typeof exports === 'object')
		exports["pariplay"] = factory();
	else
		root["pariplay"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var BaseModel = function () {
    function BaseModel() {
        _classCallCheck(this, BaseModel);
    }

    _createClass(BaseModel, [{
        key: 'inject',


        /**
         * Initialise a model
         *
         * @param  {object} obj - data to inject into model
         */
        value: function inject(obj) {
            for (var k in obj) {
                var v = obj[k];

                var lowKey = k.toLowerCase();

                if (this.keyMapping[lowKey]) {
                    var mappedKey = this.keyMapping[lowKey];

                    if (this[mappedKey] && this.preventOverwrite.indexOf(mappedKey) >= 0) {
                        continue;
                    }
                    if (this.subModels[mappedKey]) {
                        var Klass = this.subModels[mappedKey];

                        this[mappedKey] = new Klass(v);
                    } else {
                        this[mappedKey] = this._parseValues(v);
                    }

                    if (this.decodeURI.indexOf(mappedKey) >= 0 && typeof v === 'string' && v !== '') {
                        this[mappedKey] = window.decodeURIComponent(this[mappedKey]);
                    }
                } else {
                    // console.log('No mapping for', k)
                }
            }
        }

        /**
         * Get raw data from model
         *
         * @return  {object} data in model
         */

    }, {
        key: 'getData',
        value: function getData() {
            var tmp = {};

            for (var k in this.keyMapping) {
                var v = this.keyMapping[k];

                if (this[v] !== undefined && this[v] !== null) {
                    if (this[v].getData) {
                        tmp[v] = this[v].getData();
                    } else {
                        tmp[v] = this[v];
                    }
                }
            }

            return tmp;
        }

        /**
         * Get raw data from model
         *
         * @private
         * @param {string} v - value to be parsed
         * @return  {any} parses the variable into the correct data type
         */

    }, {
        key: '_parseValues',
        value: function _parseValues(v) {
            if (typeof v !== 'string') {
                return v;
            }
            if (v === '') {
                return null;
            }
            if (v === 'true') {
                return true;
            }
            if (v === 'false') {
                return false;
            }
            if (!isNaN(Number(v))) {
                return Number(v);
            }
            if (v === 'null') {
                return null;
            }

            return v;
        }
    }], [{
        key: 'init',

        /**
         * Initialise a default model attributes
         *
         */
        value: function init() {
            this.prototype.keyMapping = {};
            this.prototype.preventOverwrite = [];
            this.prototype.decodeURI = [];
            this.prototype.subModels = {};
        }
    }]);

    return BaseModel;
}();

BaseModel.init();

exports.default = BaseModel;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseModel = __webpack_require__(0);

var _baseModel2 = _interopRequireDefault(_baseModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var StatusModel = function (_BaseModel) {
    _inherits(StatusModel, _BaseModel);

    /**
     * Initialise a model
     *
     * @param  {object} obj - Ticket data
     */
    function StatusModel(obj) {
        _classCallCheck(this, StatusModel);

        var _this = _possibleConstructorReturn(this, (StatusModel.__proto__ || Object.getPrototypeOf(StatusModel)).call(this));

        _this.name = 'StatusModel';

        _this.keyMapping = {
            errcode: 'errCode',
            errmessage: 'errMessage',
            errtype: 'errType',
            balance: 'balance',
            financialmode: 'financialMode',
            roundsleft: 'roundsLeft'
        };

        _this.inject(obj);
        return _this;
    }

    /**
     * Initialise a model
     *
     * @return {boolean} has error
     */


    _createClass(StatusModel, [{
        key: 'hasError',
        value: function hasError() {
            return this.errType !== 0;
        }

        /**
         * Initialise a model
         *
         * @return {boolean} has error type 1
         */

    }, {
        key: 'hasNormalError',
        value: function hasNormalError() {
            return this.errType === 1;
        }

        /**
         * Initialise a model
         *
         * @return {boolean} has error type 2
         */

    }, {
        key: 'hasNotificationError',
        value: function hasNotificationError() {
            return this.errType === 2;
        }

        /**
         * Initialise a model
         *
         * @return {boolean} are we waiting for balance
         */

    }, {
        key: 'isWaitingOnBalance',
        value: function isWaitingOnBalance() {
            if (this.errType === 2) {
                return true;
            }

            if (typeof this.balance !== 'number') {
                return true;
            }

            if (this.balance < 0) {
                return true;
            }

            return false;
        }

        /**
         * Initialise a model
         *
         * @return {boolean} do we have tickets
         */

    }, {
        key: 'hasTickets',
        value: function hasTickets() {
            var c = this.roundsLeft;

            if (!c) {
                return false;
            }

            if (typeof c !== 'number') {
                return false;
            }

            if (c <= 0) {
                return false;
            }

            return true;
        }
    }]);

    return StatusModel;
}(_baseModel2.default);

exports.default = StatusModel;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _statusModel = __webpack_require__(1);

var _statusModel2 = _interopRequireDefault(_statusModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Balance = function () {
    _createClass(Balance, null, [{
        key: 'initClass',

        /**
         * @return {this} Returns self to allow chaining
         */
        value: function initClass() {
            this.prototype.name = 'Balance';
            this.prototype.interval = null;
            this.prototype.balanceDelay = 60000;
            this.prototype.debug = true;

            return this;
        }

        /**
         * @param  {object} options - Options
         * @param  {Pariplay.Networker} networker - Make Network calls
         * @param  {Function} balanceHandler - Method to call when the balance changes
         * @return {Pariplay.Balance} Returns self to allow chaining
         */

    }]);

    function Balance(options, networker, balanceHandler) {
        _classCallCheck(this, Balance);

        this.balanceHandler = balanceHandler;
        this.networker = networker;
        this.playerTokenId = options.playerTokenId;
        this.clientToken = options.clientToken;
        this.endpoint = options.balanceUrl;
        this.allowedBalanceAttemps = options.balanceAttemps;

        return this;
    }

    /**
     * @return {Number} Returns id of set Interval
     */


    _createClass(Balance, [{
        key: 'startInterval',
        value: function startInterval() {
            var _this = this;

            if (!this.endpoint) {
                return null;
            }

            if (this.interval) {
                return null;
            }

            this.interval = setInterval(function () {
                _this.getBalance();
            }, this.balanceDelay);

            return this.interval;
        }

        /**
         * @method
         */

    }, {
        key: 'stopInterval',
        value: function stopInterval() {
            clearInterval(this.interval);
            this.interval = null;
        }

        /**
         * @method
         */

    }, {
        key: 'getBalance',
        value: function getBalance() {
            var _this2 = this;

            var params = {
                ClientToken: this.clientToken,
                PlayerTokenId: this.playerTokenId
            };

            if (this.endpoint === null) {
                return;
            }

            this.networker.POST(this.endpoint, params, function (err, resp, code) {
                if (err || code !== 200 || !resp || resp === '') {
                    return;
                }

                var statusModel = new _statusModel2.default(resp.Status);

                if (_this2.balanceHandler) {
                    _this2.balanceHandler(statusModel.balance);
                }
            });
        }
    }]);

    return Balance;
}();

Balance.initClass();

exports.default = Balance;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _betModel = __webpack_require__(12);

var _betModel2 = _interopRequireDefault(_betModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Bet = function () {
    /**
     * @param  {object} options - Options
     * @param  {Pariplay.Networker} networker - Make Network calls
     * @return {Pariplay.Bet} Returns self to allow chaining
     */
    function Bet(options, networker) {
        _classCallCheck(this, Bet);

        this.name = 'Bet';
        this.logging = false;
        this.notificationAttempts = 0;
        this.notificationDelay = 5000;
        this.debug = false;

        this.networker = networker;

        this.notifyEndpoint = options.notifyUrl;
        this.placeBetEndpoint = options.placeBetUrl;
        this.endBetEndpoint = options.endUrl;
        this.clientToken = options.clientToken;
        this.playerTokenId = options.playerTokenId;
        this.finMode = options.financialMode;

        return this;
    }

    /**
     * @param  {Number} stake - Stake amount
     * @param  {Callback} callback - Completion handler
     */


    _createClass(Bet, [{
        key: 'place',
        value: function place(stake, callback) {
            var _this = this;

            this.notificationAttempts = 0;

            var input = {
                Stake: stake
            };

            var params = {
                ClientToken: this.clientToken,
                PlayerTokenId: this.playerTokenId,
                Input: JSON.stringify(input)
            };

            if (window.debugWinIndex !== null && window.debugWinIndex >= 0) {
                var debug = {
                    WinType: 2,
                    WinIndex: window.debugWinIndex
                };

                params.Debug = JSON.stringify(debug);
            }

            this.networker.POST(this.placeBetEndpoint, params, function (err, resp, code) {
                _this.handleResponse(err, resp, code, callback);
            });
        }

        /**
         * @param  {Callback} callback - Completion handler
         * @return {Number} Returns timeout id
         */

    }, {
        key: 'getNotifcationAfterDelay',
        value: function getNotifcationAfterDelay(callback) {
            var _this2 = this;

            return setTimeout(function () {
                return _this2._getNotifcation(callback);
            }, this.notificationDelay);
        }

        /**
        *  @private
         * @param  {Callback} callback - Completion handler
         */

    }, {
        key: '_getNotifcation',
        value: function _getNotifcation(callback) {
            var _this3 = this;

            this.notificationAttempts++;

            var params = {
                ClientToken: this.clientToken,
                PlayerTokenId: this.playerTokenId
            };

            this.networker.POST(this.notifyEndpoint, params, function (err, resp, code) {
                return _this3.handleResponse(err, resp, code, callback);
            });
        }

        /**
         * @param  {object} err - Error object
         * @param  {object} resp - Result object
         * @param  {number} code - Http code
         * @param  {Callback} callback - Completion handler
         * @return {string} Returns the state for testing
         */

    }, {
        key: 'handleResponse',
        value: function handleResponse(err, resp, code, callback) {
            // not json
            if (typeof resp === 'string') {
                try {
                    resp = JSON.parse(resp);
                } catch (e) {
                    var _err = {
                        msg: 'Corrupt data',
                        code: 'PLACE_BET_FAILED'
                    };

                    callback(_err, null, code);

                    return 'corrupt';
                }
            }

            // Unknown Error
            if (code !== 200 || err || !resp || !resp.Status) {
                var _err2 = {
                    msg: 'Invalid response',
                    code: 'PLACE_BET_FAILED'
                };

                callback(_err2, null, code);

                return 'invalid';
            }

            var betModel = new _betModel2.default(resp);
            var statusModel = betModel.status;

            // Error 1
            if (statusModel.hasNormalError()) {
                var ERR_CODE = 'PLACE_BET_FAILED';

                if (statusModel.errCode === 112) {
                    if (this.finMode) {
                        ERR_CODE = 'NO_TICKETS_LEFT';
                    } else {
                        ERR_CODE = 'INSUFFICIENT_FUNDS';
                    }
                }

                var _err3 = {
                    code: ERR_CODE,
                    msg: statusModel.errMessage
                };

                callback(_err3, betModel, code);

                return 'err1';
            }

            // Error 2
            if (statusModel.hasNotificationError()) {
                var _err4 = {
                    code: 'WAITING_ON_NOTIFICATION',
                    msg: statusModel.errMessage
                };

                callback(_err4, betModel, code);

                this.getNotifcationAfterDelay(callback);

                return 'err2';
            }

            // Success
            callback(null, betModel, code);

            return 'success';
        }

        /**
         * @param  {object} ticketId - The id of the ticket
         * @param  {Callback} callback - Completion handler
         */

    }, {
        key: 'end',
        value: function end(ticketId, callback) {
            if (!this.endBetEndpoint) {
                return;
            }

            var params = {
                ClientToken: this.clientToken,
                PlayerTokenId: this.playerTokenId,
                Id: ticketId
            };

            this.networker.POST(this.endBetEndpoint, params, function (err, resp, code) {
                if (callback) {
                    callback(err, resp, code);
                }
            });
        }
    }]);

    return Bet;
}();

exports.default = Bet;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  Helper Class
 */
var Helper = function () {
    function Helper() {
        _classCallCheck(this, Helper);
    }

    _createClass(Helper, null, [{
        key: 'getQueryAsObj',

        /**
         * @static
         * @param {string} query - url query string example ?key=val&foo=bar
         * @return {object} dictionary representation of the query string
         */
        value: function getQueryAsObj(query) {
            if (!query) {
                query = window.location.search;
            }

            if (query[0] === '?') {
                query = query.substring(1);
            }

            var tmp = {};
            var vars = query.split('&');
            var i = 0;

            while (i < vars.length) {
                var pair = vars[i].split('=');

                tmp[pair[0]] = pair[1];
                i++;
            }

            return tmp;
        }
    }]);

    return Helper;
}();

exports.default = Helper;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Linker = function () {
    /**
     * Constructs the object.
     *
     * @param  {Pariplay.Messager}  messager     - to send html5 messags
     * @param  {Boolean}            isMobile     - is this thing Mobile or not
     * @param  {Function}           backHandler  - The function to be called when navigating back
     * @return {Pariplay.Linker}    Returns self to allow chaining
     */
    function Linker(messager, isMobile, backHandler) {
        _classCallCheck(this, Linker);

        this.name = 'Linker';
        this.messager = messager;
        this.isMobile = isMobile;
        this.backHandler = backHandler;

        return this;
    }

    /**
     * @param  {string} url - Url of where to navigate
     * @return {string} reference of what occurred for testing
     */


    _createClass(Linker, [{
        key: 'home',
        value: function home(url) {
            if (!url || typeof url !== 'string' || url === '') {
                return 'none';
            }

            this.messager.postQuit('RealityCheck', url);

            if (url === '(api)') {
                return 'api';
            }

            if (url === '(back)') {
                this.backHandler();

                return 'back';
            }

            if (url === '(888bingo)') {
                this.messager.post888Lobby();

                return '888';
            }

            if (!this.validateURL(url)) {
                return 'fail';
            }

            try {
                window.top.location.href = url;
            } catch (e) {
                return 'fail';
            }

            return 'url';
        }

        /**
         * @param  {string} url - Url of where to navigate
         * @return {string} reference of what occurred for testing
         */

    }, {
        key: 'cashier',
        value: function cashier(url) {
            if (!url || typeof url !== 'string' || url === '') {
                return 'none';
            }

            this.messager.postCashier('InsufficientFunds', url);

            if (url === '(api)') {
                return 'api';
            }

            if (url === '(888bingo)') {
                this.messager.post888Cashier();

                return '888';
            }

            if (!this.validateURL(url)) {
                return 'fail';
            }

            try {
                if (this.isMobile) {
                    window.top.location.href = url;

                    return 'url-mobile';
                }

                window.open(url);

                return 'url-desktop';
            } catch (e) {
                return 'fail';
            }
        }

        /**
         * @param  {string} url - Url of where to navigate
         * @return {string} reference of what occurred for testing
         */

    }, {
        key: 'history',
        value: function history(url) {
            if (!url || typeof url !== 'string' || url === '') {
                return 'none';
            }

            this.messager.postHistory('RealityCheck', url);

            if (!this.validateURL(url)) {
                return 'fail';
            }

            try {
                if (this.isMobile) {
                    window.top.location.href = url;

                    return 'url-mobile';
                }

                window.open(url);

                return 'url-desktop';
            } catch (e) {
                return 'fail';
            }
        }

        /**
         * @param  {string} url - Url of where to navigate
         * @return {string} reference of what occurred for testing
         */

    }, {
        key: 'buyMore',
        value: function buyMore(url) {
            if (!url || typeof url !== 'string' || url === '') {
                return 'none';
            }

            if (url === '(api)') {
                this.messager.postBuyMoreTickets();

                return 'api';
            }

            this.messager.postQuit('eCommerceBuyMore', url);

            if (!this.validateURL(url)) {
                return 'fail';
            }

            try {
                window.top.location.href = url;
            } catch (e) {
                return 'fail';
            }

            return 'url';
        }

        /**
         * @param  {string} url - Url of where to navigate
         * @return {boolean} whether its valid or not
         */

    }, {
        key: 'validateURL',
        value: function validateURL(url) {
            if (!url || typeof url !== 'string' || url === '') {
                return false;
            }

            return true;
        }
    }]);

    return Linker;
}();

exports.default = Linker;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _statusModel = __webpack_require__(1);

var _statusModel2 = _interopRequireDefault(_statusModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Load = function () {
    _createClass(Load, null, [{
        key: 'init',

        /**
         * @return {Pariplay.Bet} Returns self to allow chaining
         */
        value: function init() {
            this.prototype.name = 'Load';
            this.prototype.debug = true;
            this.prototype.attempts = 0;
            this.prototype.balanceDelay = 5000;
            this.prototype.balanceAttempts = 4;

            return this;
        }

        /**
         * @param  {object} options - Options
         * @param  {Pariplay.Networker} networker - Make Network calls
         * @return {Pariplay.Load} Returns self to allow chaining
         */

    }]);

    function Load(options, networker) {
        _classCallCheck(this, Load);

        this.networker = networker;
        this.options = options;

        return this;
    }

    /**
     * @param  {Callback} callback - completion handler
     */


    _createClass(Load, [{
        key: 'loadGame',
        value: function loadGame(callback) {
            var _this = this;

            var params = {
                ClientToken: this.options.clientToken,
                GameCode: this.options.gameCode,
                CurrencyCode: this.options.currencyCode,
                LanguageCode: this.options.languageCode,
                FinancialMode: this.options.financialMode
            };

            if (this.options.extraData) {
                params.ExtraData = this.options.extraData;
            }

            this.networker.POST(this.options.loadGameEndpoint, params, function (err, resp, code) {
                _this.handleResponse(resp, err, code, function (validResponse, handledResp) {
                    return callback(validResponse, handledResp, code);
                });
            });
        }

        /**
         * @param  {object} resp - Result object
         * @param  {object} err - Error object
         * @param  {number} code - Http code
         * @param  {Callback} callback - Completion handler
         * @return {string} Returns the state for testing
         */

    }, {
        key: 'handleResponse',
        value: function handleResponse(resp, err, code, callback) {
            // try and parse json
            if (typeof resp === 'string') {
                try {
                    resp = JSON.parse(resp);
                } catch (e) {
                    var _err = {
                        msg: 'Invalid Response',
                        code: 'LOAD_GAME_FAILED'
                    };

                    callback(_err, null, code);

                    return 'corrupt';
                }
            }

            if (code !== 200 || err || !resp || resp === '' || (typeof resp === 'undefined' ? 'undefined' : _typeof(resp)) !== 'object') {
                var _err2 = {
                    msg: 'Invalid Response',
                    code: 'LOAD_GAME_FAILED'
                };

                callback(_err2, null, code);

                return 'invalid';
            }

            callback(null, resp, code);

            return 'success';
        }

        /**
         * @param  {Pariplay.model.StatusModel} statusModel - The load game status Model
         * @param  {boolean} isValidResponse - Did it pass the initial tests
         * @param  {Callback} callback - Completion handler
         */

    }, {
        key: 'getInitialBalance',
        value: function getInitialBalance(statusModel, isValidResponse, callback) {
            // Unknown fail
            if (!statusModel && !statusModel.hasNormalError) {
                var err = {
                    msg: 'Invalid Response',
                    code: 'LOAD_GAME_FAILED'
                };

                callback(err, null, -999);

                return;
            }
            // Server error
            if (statusModel.hasNormalError()) {
                var _err3 = {
                    code: 'LOAD_GAME_FAILED',
                    msg: statusModel.errMessage
                };

                callback(_err3, statusModel.balance, -999);

                return;
            }
            // the load game response was perfect
            if (!statusModel.isWaitingOnBalance()) {
                callback(null, statusModel.balance, 200);

                return;
            }

            // the load game response was ok but missing the balance
            var waitingErr = {
                code: 'WAITING_ON_BALANCE',
                msg: statusModel.errMessage
            };

            callback(waitingErr, statusModel.balance, 200);

            // attempt to get the balance before we proceed
            this.attempts = 0;

            this.requestBalance(function (newStatusModel, err, code) {
                if (newStatusModel) {
                    callback(err, newStatusModel.balance, code);

                    return;
                }

                var failedErr = {
                    code: 'WAITING_ON_BALANCE_FAILED',
                    msg: statusModel.errMessage
                };

                callback(failedErr, null, code);
            });
        }

        /**
         * @private
         * @param  {Callback} callback - Completion handler
         * @return {Number} Returns timeout id
         */

    }, {
        key: '_requestBalance',
        value: function _requestBalance(callback) {
            var _this2 = this;

            return setTimeout(function () {
                _this2.requestBalance(callback);
            }, this.balanceDelay);
        }

        /**
         * @param  {Callback} callback - Completion handler
         */

    }, {
        key: 'requestBalance',
        value: function requestBalance(callback) {
            var _this3 = this;

            var params = {
                ClientToken: this.options.clientToken,
                PlayerTokenId: this.options.playerTokenId
            };

            if (!this.options.balanceUrl) {
                return;
            }

            this.networker.POST(this.options.balanceUrl, params, function (err, resp, code) {
                _this3.attempts++;

                if (code !== 200 || !resp || !resp.Status) {
                    callback(null, err, code);

                    return;
                }

                var statusModel = new _statusModel2.default(resp.Status);

                if (statusModel.isWaitingOnBalance()) {
                    if (_this3.attempts < _this3.balanceAttempts) {
                        _this3._requestBalance(callback);

                        return;
                    }
                    callback(null, err, code);

                    return;
                }

                callback(statusModel, err, code);
            });
        }
    }]);

    return Load;
}();

Load.init();

exports.default = Load;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Messager = function () {
    /**
     * @param  {object} options - Options
     * @return {Pariplay.Messager} Returns self to allow chaining
     */
    function Messager(options) {
        _classCallCheck(this, Messager);

        this.sender = options.gameCode;
        this.lang = options.languageCode;

        return this;
    }

    /**
     * @param  {object} data - Object you want to post
     * @return {Pariplay.Load} Object you tried to post
     */


    _createClass(Messager, [{
        key: 'post',
        value: function post(data) {
            window.parent.postMessage(data, '*');

            return data;
        }

        /**
         * @param  {number} w - window width
         * @param  {number} h - window height
         * @return {Pariplay.Load} Object you tried to post
         */

    }, {
        key: 'postResize',
        value: function postResize(w, h) {
            return this.post({
                type: 'resize',
                width: w,
                height: h
            });
        }

        /**
         * Post this as soon as you can
         *
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postOnAppFrameReady',
        value: function postOnAppFrameReady() {
            return this.post({
                type: 'onAppFrameReady',
                sender: this.sender
            });
        }

        /**
         * Post After receiving LoadGame
         *
         * @param  {boolean} success - Whether the LoadGame was successful or not
         * @param  {object}  status  The load game
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postLoadGame',
        value: function postLoadGame(success, status) {
            return this.post({
                type: 'gameDataLoaded',
                sender: this.sender,
                lang: this.lang,
                data: {
                    success: success,
                    status: status
                }
            });
        }

        /**
         * Post after Currency initialization:
         *
         * @param  {string} currCode - Currency code e.g. EUR
         * @param  {string} currSymbol - Currency symbol e.g €
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postCurrencyStatus',
        value: function postCurrencyStatus(currCode, currSymbol) {
            return this.post({
                type: 'currencyStatus',
                sender: this.sender,
                lang: this.lang,
                data: {
                    currencyCode: currCode,
                    currencySymbol: currSymbol
                }
            });
        }

        /**
         * Post Before sending PlaceBet
         *
         * @param  {string} betValue - Stake
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postBeforePlaceBet',
        value: function postBeforePlaceBet(betValue) {
            return this.post({
                type: 'roundStart',
                sender: this.sender,
                lang: this.lang,
                data: {
                    totalBet: betValue
                }
            });
        }

        /**
         * Post After successful receiving PlaceBet
         *
         * @param  {string} ticketId - Id of bet
         * @param  {number} balanceBefore - The balance before
         * @param  {number} ticketsBefore - How many tickets before
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postAfterPlaceBet',
        value: function postAfterPlaceBet(ticketId, balanceBefore, ticketsBefore) {
            return this.post({
                type: 'roundStarted',
                sender: this.sender,
                lang: this.lang,
                data: {
                    id: ticketId,
                    balanceBefore: balanceBefore,
                    ticketsLeftBefore: ticketsBefore
                }
            });
        }

        /**
         * Post when user pressed 'Reveal All' or 'Stop' button:
         *
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postRevealAll',
        value: function postRevealAll() {
            return this.post({
                type: 'revealAll',
                sender: this.sender,
                lang: this.lang
            });
        }

        /**
         * Post After round is completed
         *
         * @param  {string} ticketId - Id of bet
         * @param  {number} winAmount - amount won
         * @param  {number} balanceAfter - The balance after
         * @param  {number} ticketsAfter - How many tickets after
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postRoundEnded',
        value: function postRoundEnded(ticketId, winAmount, balanceAfter, ticketsAfter) {
            return this.post({
                type: 'roundEnded',
                sender: this.sender,
                lang: this.lang,
                data: {
                    id: ticketId,
                    win: winAmount,
                    balanceAfter: balanceAfter,
                    ticketsLeftAfter: ticketsAfter
                }
            });
        }

        /**
         * Post after any actual update of visible balance
         *
         * @param  {number} amount - New balance amount
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postUpdateBalance',
        value: function postUpdateBalance(amount) {
            return this.post({
                type: 'balance',
                sender: this.sender,
                lang: this.lang,
                data: {
                    amount: amount
                }
            });
        }

        /**
         * Post After when user choose to leave
         * e.g.
         * User pressed Home button of ribbon or
         * Exit button of RealityCheck popup or
         * Exit button of eCommerce Finish popup or
         * Continue button of VoucherSummary popup (causes restart) or
         * Exit button of VoucherSummary popup:
         *
         * @param  {string} reason - What action the user chose
         * @param  {string} url - Where they are going
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postQuit',
        value: function postQuit(reason, url) {
            return this.post({
                type: 'quit',
                sender: this.sender,
                lang: this.lang,
                data: {
                    reason: reason, // 'Ribbon' | 'RealityCheck' | 'eCommerceExit' | 'VoucherSummaryContinue' | 'VoucherSummaryExit',
                    target: url
                }
            });
        }

        /**
         * User pressed Cashier button of ribbon or
         * Deposit button of Insufficient Funds message (causes Quit in mobile mode):
         *
         * @param  {string} reason - What action the user chose 'Cashier' | 'InsufficientFunds'
         * @param  {string} url - Where they are going
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postCashier',
        value: function postCashier(reason, url) {
            if (!reason) {
                reason = 'InsufficientFunds';
            }

            return this.post({
                type: 'cashier',
                sender: this.sender,
                lang: this.lang,
                data: {
                    reason: reason,
                    target: url
                }
            });
        }

        /**
         * User pressed 'Buy More Tickets' of eCommerce Finish popup or
         * 'Deposit' button in ErrorMessage with ErrorCode 112 in eCommerce mode:
         *
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postBuyMoreTickets',
        value: function postBuyMoreTickets() {
            return this.post({
                type: 'buyMoreTickets',
                sender: this.sender,
                lang: this.lang
            });
        }

        /**
         * Post when all rounds finished (eCommerce mode):
         * THIS IS THE ONE THE TELLS PP TO SHOW THEIR MODEL
         *
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postNoRoundsLeft',
        value: function postNoRoundsLeft() {
            return this.post({
                type: 'noRoundsLeft',
                sender: this.sender,
                lang: this.lang
            });
        }

        /**
         * User pressed History button on Reality Check popup (causes Quit in mobile mode)
         *
         * @param  {string} reason - What action the user chose
         * @param  {string} url - Where they are going
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postHistory',
        value: function postHistory(reason, url) {
            if (!reason) {
                reason = 'RealityCheck';
            }

            return this.post({
                type: 'history',
                sender: this.sender,
                lang: this.lang,
                data: {
                    reason: reason,
                    target: url
                }
            });
        }

        /**
         * User pressed Help button on Reality Check popup (causes Quit in mobile mode)
         *
         * @param  {string} reason - What action the user chose
         * @param  {string} url - Where they are going
         * @return {object} Object you tried to post
         */

    }, {
        key: 'postHelp',
        value: function postHelp(reason, url) {
            if (!reason) {
                reason = 'Ribbon';
            }

            return this.post({
                type: 'help',
                sender: this.sender,
                lang: this.lang,
                data: {
                    reason: reason,
                    target: url
                }
            });
        }

        /**
         * Only for 888 when someone click 'home'
         *
         * @return {object} Object you tried to post
         */

    }, {
        key: 'post888Lobby',
        value: function post888Lobby() {
            return this.post({
                method: 'lobby',
                data: {}
            });
        }

        /**
         * Only for 888 when someone click 'cashier'|'deposit'
         *
         * @return {object} Object you tried to post
         */

    }, {
        key: 'post888Cashier',
        value: function post888Cashier() {
            return this.post({
                method: 'cashier',
                data: {}
            });
        }
    }]);

    return Messager;
}();

exports.default = Messager;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseModel = __webpack_require__(0);

var _baseModel2 = _interopRequireDefault(_baseModel);

var _statusModel = __webpack_require__(1);

var _statusModel2 = _interopRequireDefault(_statusModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var PariplayModel = function (_BaseModel) {
    _inherits(PariplayModel, _BaseModel);

    /**
     * Initialise a model
     *
     * @param  {object} obj - Ticket data
     */
    function PariplayModel(obj) {
        _classCallCheck(this, PariplayModel);

        var _this = _possibleConstructorReturn(this, (PariplayModel.__proto__ || Object.getPrototypeOf(PariplayModel)).call(this));

        _this.name = 'PariplayModel';

        // defaults
        _this.rgsUrl = '//rgs.pariplaygames.com';
        _this.apiPath = '/client/';
        _this.loadGameEndpoint = 'LoadGame';
        _this.currencyCode = 'EUR';
        _this.dontShowBalance = false;
        _this.dontShowStake = false;
        _this.showTicketId = false;
        _this.financialMode = 0;
        _this.playerTokenId = 0;
        _this.showBuyMoreButton = false;
        _this.ukRegulations = false;

        // case sensitivity is no guaranteed
        // by Pariplay

        _this.keyMapping = {

            // QueryString (often doubles in loadGame)
            gamecode: 'gameCode',
            token: 'clientToken',
            clienttoken: 'clientToken',
            currencycode: 'currencyCode',
            lang: 'languageCode',
            financialmode: 'financialMode',
            rgsurl: 'rgsUrl',
            homeurl: 'homeUrl',
            historyurl: 'historyUrl',
            buymoreurl: 'buyMoreUrl',
            cashierurl: 'cashierUrl',
            dontshowbalance: 'dontShowBalance',
            dontshowstake: 'dontShowStake',
            showticketid: 'showTicketId',
            showbuymorepopup: 'showBuyMorePopup',
            sound: 'sound',
            extradata: 'extraData',
            debug: 'debug',
            fps: 'fps',

            // Load Game (additional)
            defaultstake: 'defaultStake',
            balanceurl: 'balanceUrl',
            playertokenid: 'playerTokenId',
            endurl: 'endUrl',
            helpurl: 'helpUrl',
            notifyurl: 'notifyUrl',
            paytable: 'paytable',
            placebeturl: 'placeBetUrl',
            maxmultiplier: 'maxMultiplier',
            replayoutcome: 'replayOutcome',
            realitychecktimeout: 'realityCheckTimeout',
            stakes: 'stakes',
            status: 'status',
            ukregulations: 'ukRegulations',
            autobetrounds: 'autoplayOptions',

            // Calculated
            maxprize: 'maxPrize',
            baselanguage: 'baseLanguage',
            showbuymorebutton: 'showBuyMoreButton',
            showhomebutton: 'showHomeButton',
            showhelpbutton: 'showHelpButton',
            showcashierbutton: 'showCashierButton',
            showhistorybutton: 'showHistoryButton',
            showrealitycheck: 'showRealityCheck',
            realitycheckseconds: 'realityCheckSeconds'
        };

        // Prevent the loadGame overwriting the query params
        _this.preventOverwrite = ['gameCode', 'cashierUrl', 'homeUrl'];

        _this.decodeURI = ['helpUrl', 'cashierUrl', 'homeUrl', 'historyUrl', 'buyMoreUrl'];

        _this.subModels = {
            status: _statusModel2.default
        };

        _this.inject(obj);
        return _this;
    }

    /**
     * Add extra functionality to inject
     *
     * @private
     * @param {object} obj - raw data
     */


    _createClass(PariplayModel, [{
        key: 'inject',
        value: function inject(obj) {
            _get(PariplayModel.prototype.__proto__ || Object.getPrototypeOf(PariplayModel.prototype), 'inject', this).call(this, obj);

            if (this.status && this.status.financialMode) {
                this.financialMode = this.status.financialMode;
            }

            if (this.languageCode) {
                this.languageCode = this._parseLangCode(this.languageCode);
                this.baseLanguage = this.languageCode.substring(0, 2);
            }

            if (this.rgsUrl && this.apiPath) {
                this.apiEndpoint = this.rgsUrl + this.apiPath;
            }

            this.maxPrize = this.getMaxPrize();
            this.showHomeButton = !!this.homeUrl;
            this.showHelpButton = !!this.helpUrl;
            this.showHistoryButton = !!this.historyUrl;
            this.showCashierButton = !!this.cashierUrl;
            this.showBuyMoreButton = this.shouldShowBuyMore();
            this.showRealityCheck = this.shouldShowRealityCheck();
        }

        /**
         * Gets the maximum prize.
         *
         * @return {number}  The maximum prize.
         */

    }, {
        key: 'getMaxPrize',
        value: function getMaxPrize() {
            if (!this.maxMultiplier || !this.stakes) {
                return 0;
            }

            var a = this.maxMultiplier * this.stakes[this.stakes.length - 1];

            return Math.round(a);
        }

        /**
         * Should we show the reality check
         *
         * @return {boolean}  whether or not to show it
         */

    }, {
        key: 'shouldShowRealityCheck',
        value: function shouldShowRealityCheck() {
            var rct = this.realityCheckTimeout;

            if (typeof rct !== 'number' || rct <= 0) return false;

            this.realityCheckSeconds = this.realityCheckTimeout * 60;

            return true;
        }

        /**
         * SHould show buy more
         *
         * @return {boolean}  whether or not to show it
         */

    }, {
        key: 'shouldShowBuyMore',
        value: function shouldShowBuyMore() {
            if (this.showBuyMorePopup && (this.buyMoreUrl || this.homeUrl)) {
                return true;
            }

            return false;
        }

        /**
         * Erro check the langCode
         *
         * @private
         * @param {string} locale - raw locale
         * @return {string} the corrected locale code
         */

    }, {
        key: '_parseLangCode',
        value: function _parseLangCode(locale) {
            if (typeof locale !== 'string') {
                return '';
            }

            var parts = locale.split('-');

            // try underscore instead
            if (parts.length === 1 && locale.length > 2) {
                parts = locale.split('_');
            }

            var lang = parts[0].toLowerCase();

            if (parts[1] && parts[1].length > 1 && parts[1] !== '' && parts[1] !== '-') {
                var country = parts[1].toUpperCase();

                lang = lang + '-' + country;
            }

            return lang;
        }
    }]);

    return PariplayModel;
}(_baseModel2.default);

exports.default = PariplayModel;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 */
var Networker = function () {
    /**
     * Post After round is completed
     *
     * @param  {string} apiEndpoint - Id of bet
     * @return {Pariplay.Netowrker} For chaining
     */
    function Networker(apiEndpoint) {
        _classCallCheck(this, Networker);

        this.name = 'Networker';
        this.apiEndpoint = apiEndpoint;

        return this;
    }

    /**
     * Post After round is completed
     *
     * @param  {string} path - Api path
     * @param  {object} params - Body params
     * @param  {Callback} callback - Completion handler
     */


    _createClass(Networker, [{
        key: 'POST',
        value: function POST(path, params, callback) {
            var endpoint = this.apiEndpoint + path;

            if (!params) {
                params = {};
            }

            params.Rand = Math.floor(Math.random() * 10000000);
            params = this.serializeParams(params);

            var request = new XMLHttpRequest();

            request.open('POST', endpoint, true);
            request.setRequestHeader('Accept', 'application/json, text/javascript, */*');
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            request.timeout = 120000;

            function completionHandler() {
                var resp = request.responseText;

                if (request.status >= 200 && request.status < 400) {
                    try {
                        if (resp !== '') {
                            resp = JSON.parse(resp);
                        }
                    } catch (e) {
                        callback('Fail', resp, request.status);

                        return;
                    }

                    callback(null, resp, request.status);
                } else {
                    callback('Fail', resp, request.status);
                }
            }

            request.onload = completionHandler;

            request.onerror = function (err) {
                return callback(err, null, request.status);
            };

            request.ontimeout = function () {
                return callback('timeout', null, request.status);
            };

            request.send(params);
        }

        /**
         * Turns a js object in http body params
         *
         * @param  {string} params - Your params as an object
         * @return  {str} Serialized params
         */

    }, {
        key: 'serializeParams',
        value: function serializeParams(params) {
            var str = '';

            for (var key in params) {
                if (str !== '') {
                    str += '&';
                }
                str += key + '=' + encodeURIComponent(params[key]);
            }

            return str;
        }
    }]);

    return Networker;
}();

exports.default = Networker;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Pariplay = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _load = __webpack_require__(6);

var _load2 = _interopRequireDefault(_load);

var _bet = __webpack_require__(3);

var _bet2 = _interopRequireDefault(_bet);

var _balance = __webpack_require__(2);

var _balance2 = _interopRequireDefault(_balance);

var _linker = __webpack_require__(5);

var _linker2 = _interopRequireDefault(_linker);

var _messager = __webpack_require__(7);

var _messager2 = _interopRequireDefault(_messager);

var _networker = __webpack_require__(9);

var _networker2 = _interopRequireDefault(_networker);

var _helper = __webpack_require__(4);

var _helper2 = _interopRequireDefault(_helper);

var _pariplayModel = __webpack_require__(8);

var _pariplayModel2 = _interopRequireDefault(_pariplayModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This the entry point for the Pariplay class, every method in this class needs to be implemented
 * in you application in order complete all the neccessary functionality the Pariplay RGS documentation requires.
 *
 * None of the other classes nor their methods need to be used by your application.
 */
var Pariplay = exports.Pariplay = function () {
    /**
     * @callback Callback
     * @param {object} err - Error
     * @param {object} resp - Response
     * @param {number} code - HTTP Code
     */

    /**
     * This should fire before the loadGame request and you must pass it the url
     * queryData
     *
     * @param  {Object|String}  queryData  - url query data
     * @param  {Boolean}        isMobile   - is this thing Mobile or not
     * @param  {Function}       forceBack  - A handler for when the game should force a real back navigation
     * @return {Pariplay}       Returns self to allow chaining
     */
    function Pariplay(queryData, isMobile, forceBack) {
        _classCallCheck(this, Pariplay);

        if (typeof queryData === 'string') {
            queryData = _helper2.default.getQueryAsObj(queryData);
        }

        this.isMobile = false;
        this.options = new _pariplayModel2.default(queryData);
        this.networker = new _networker2.default(this.options.apiEndpoint);
        this.messager = new _messager2.default(this.options);
        this.linker = new _linker2.default(this.messager, this.isMobile, forceBack);
        this.load = new _load2.default(this.options, this.networker);

        this.messager.postOnAppFrameReady();

        if (typeof isMobile === 'boolean') {
            this.setIsMobile(isMobile);
        }

        return this;
    }

    /**
     * @param  {boolean} isMobile - is this thing Mobile or not
     */


    _createClass(Pariplay, [{
        key: 'setIsMobile',
        value: function setIsMobile(isMobile) {
            this.isMobile = isMobile;
            this.linker.isMobile = isMobile;
        }

        /**
         * Load Game data from server
         *
         * @public
         * @param  {Callback} callback - completion handler
         */

    }, {
        key: 'loadGame',
        value: function loadGame(callback) {
            var _this = this;

            this.load.loadGame(function (err, handledResp, code) {
                var balanceHandler = function balanceHandler(balance) {
                    if (_this.balanceHandler) {
                        _this.balanceHandler(balance);
                    }
                };

                _this.options.inject(handledResp);
                _this.options.isValid = !err;
                _this.bet = new _bet2.default(_this.options, _this.networker);
                _this.balance = new _balance2.default(_this.options, _this.networker, balanceHandler);

                if (_this.options.status && _this.options.status.getData) {
                    _this.messager.postLoadGame(_this.options.isValid, _this.options.status);
                }

                callback(err, _this.options, code);
            });
        }

        /**
         * Check if we have a balance if not then we need to get it
         * @param  {function} options - options for checking balance
         * @param  {Callback} callback - completion handler
         */

    }, {
        key: 'getInitialBalance',
        value: function getInitialBalance(options, callback) {
            var _this2 = this;

            this.load.getInitialBalance(options.status, options.isValid, function (err, balance, code) {
                if (_this2.balance && balance >= 0) {
                    _this2.balance.startInterval();
                }

                callback(err, balance, code);
            });
        }

        /**
         * Place a bet
         *
         * @param  {number} stake - value of bet
         * @param  {Callback} callback - completion handler
         */

    }, {
        key: 'placeBet',
        value: function placeBet(stake, callback) {
            var _this3 = this;

            this.messager.postBeforePlaceBet(stake);
            this.bet.place(stake, function (err, betModel, code) {
                if (!err) {
                    _this3.messager.postAfterPlaceBet(betModel.ticket.id, betModel.balance.balanceBefore, betModel.balance.roundsLeft);
                }

                _this3.balance.stopInterval();

                callback(err, betModel, code);
            });
        }

        /**
         * Setup a replay betmodel from  a load game response
         *
         * @param  {object} resp - Load game response
         * @param  {Callback} callback - completion handler
         */

    }, {
        key: 'replayBet',
        value: function replayBet(resp, callback) {
            this.bet.handleResponse(null, resp, 200, function (err, betModel, code) {
                betModel.isReplay = true;
                callback(err, betModel, code);
            });
        }

        /**
         * Tell Pariplay bet has been witnessed by user
         *
         * @param  {object} data - Load game response
         * @param  {Callback} callback - completion handler
         */

    }, {
        key: 'endBet',
        value: function endBet(data, callback) {
            this.messager.postRoundEnded(data.ticketId, data.totalWinAmount, data.balanceAfter, data.roundsLeftAfter);
            this.balance.startInterval();
            this.bet.end(data.ticketId, function (err, resp, code) {
                if (callback) {
                    callback(err, resp, code);
                }
            });
        }

        /**
         * Tell Pariplay the currency has loaded
         *
         * @param  {object} data - message response
         * @return {object} data sent
         */

    }, {
        key: 'currencyLoaded',
        value: function currencyLoaded(data) {
            return this.messager.postCurrencyStatus(data.cc, data.cs);
        }

        /**
         * Tell Pariplay the balance changed
         *
         * @param  {object} amount - message response
         * @return {object} data sent
         */

    }, {
        key: 'balanceChanged',
        value: function balanceChanged(amount) {
            return this.messager.postUpdateBalance(amount);
        }

        /**
         * Tell Pariplay the we are out of tickets
         * THIS IS THE ONE THE TELLS PP TO SHOW THEIR MODEL
         *
         * @param  {object} amount - message response
         * @return {object} data sent
         */

    }, {
        key: 'noTicketsLeft',
        value: function noTicketsLeft() {
            return this.messager.postNoRoundsLeft();
        }

        /**
         * Tell Pariplay the game will reveal all
         *
         * @return {object} data sent
         */

    }, {
        key: 'willRevealAll',
        value: function willRevealAll() {
            return this.messager.postRevealAll();
        }

        /**
         * Tell Pariplay the viewport resized
         *
         * @param  {number} w - width
         * @param  {number} h - height
         * @return {Pariplay} Returns self to allow chaining
         */

    }, {
        key: 'resize',
        value: function resize(w, h) {
            return this.messager.postResize(w, h);
        }

        /**
         * Navigate user to homeUrl
         *
         * @return {string} result of action
         */

    }, {
        key: 'goHome',
        value: function goHome() {
            return this.linker.home(this.options.homeUrl);
        }

        /**
         * Navigate user to casier url
         *
         * @return {string} result of action
         */

    }, {
        key: 'goCashier',
        value: function goCashier() {
            return this.linker.cashier(this.options.cashierUrl);
        }

        /**
         * Navigate user to buymore url
         *
         * @return {string} result of action
         */

    }, {
        key: 'goBuyMore',
        value: function goBuyMore() {
            return this.linker.buyMore(this.options.buyMoreUrl);
        }

        /**
         * Navigate user to history url
         *
         * @return {string} result of action
         */

    }, {
        key: 'goHistory',
        value: function goHistory() {
            return this.linker.history(this.options.historyUrl);
        }
    }]);

    return Pariplay;
}();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseModel = __webpack_require__(0);

var _baseModel2 = _interopRequireDefault(_baseModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var BalanceModel = function (_BaseModel) {
    _inherits(BalanceModel, _BaseModel);

    /**
    * Initialise a model
    *
    * @param {object} obj - data for model
    */
    function BalanceModel(obj) {
        _classCallCheck(this, BalanceModel);

        var _this = _possibleConstructorReturn(this, (BalanceModel.__proto__ || Object.getPrototypeOf(BalanceModel)).call(this));

        _this.name = 'BalanceModel';

        _this.keyMapping = {
            balancebefore: 'balanceBefore',
            balanceafter: 'balanceAfter',
            roundsleftbefore: 'roundsLeftBefore',
            roundsleftafter: 'roundsLeftAfter',
            totalwinamount: 'totalWinAmount'
        };

        _this.inject(obj);
        return _this;
    }

    return BalanceModel;
}(_baseModel2.default);

exports.default = BalanceModel;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseModel = __webpack_require__(0);

var _baseModel2 = _interopRequireDefault(_baseModel);

var _balanceModel = __webpack_require__(11);

var _balanceModel2 = _interopRequireDefault(_balanceModel);

var _statusModel = __webpack_require__(1);

var _statusModel2 = _interopRequireDefault(_statusModel);

var _ticketModel = __webpack_require__(13);

var _ticketModel2 = _interopRequireDefault(_ticketModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var BetModel = function (_BaseModel) {
    _inherits(BetModel, _BaseModel);

    /**
     * Initialise a model
     *
     * @param  {object} obj - Ticket data
     */
    function BetModel(obj) {
        _classCallCheck(this, BetModel);

        var _this = _possibleConstructorReturn(this, (BetModel.__proto__ || Object.getPrototypeOf(BetModel)).call(this));

        _this.name = 'BetModel';

        _this.isReplay = false;

        _this.keyMapping = {
            isReplay: 'isReplay',
            input: 'input',
            balance: 'balance',
            status: 'status',
            ticket: 'ticket'
        };

        _this.subModels = {
            balance: _balanceModel2.default,
            status: _statusModel2.default,
            ticket: _ticketModel2.default
        };

        _this.inject(obj);
        return _this;
    }

    /**
     * @return {number} ticket id
     */


    _createClass(BetModel, [{
        key: 'getTicketId',
        value: function getTicketId() {
            return this.ticket.id;
        }

        /**
         * @return {array} the matrix of the game
         */

    }, {
        key: 'getMatrix',
        value: function getMatrix() {
            return this.ticket.matrixIndexes;
        }

        /**
         * @return {number} win index
         */

    }, {
        key: 'getWinIndex',
        value: function getWinIndex() {
            return this.ticket.winIndex;
        }

        /**
         * @return {number} possible win index
         */

    }, {
        key: 'getWinPossIndex',
        value: function getWinPossIndex() {
            return this.ticket.winPossIndex;
        }

        /**
         * @return {boolean} did win
         */

    }, {
        key: 'isWin',
        value: function isWin() {
            return this.ticket.isWin;
        }

        /**
         * @return {number} total bet (stake)
         */

    }, {
        key: 'getTotalBet',
        value: function getTotalBet() {
            return this.ticket.totalBet;
        }

        /**
         * @return {number} rounds after
         */

    }, {
        key: 'getTotalWinAmount',
        value: function getTotalWinAmount() {
            return this.ticket.totalWinAmount;
        }

        /**
         * @return {number} balance before
         */

    }, {
        key: 'getBalanceBefore',
        value: function getBalanceBefore() {
            return this.balance.balanceBefore;
        }

        /**
         * @return {number} balance after
         */

    }, {
        key: 'getBalanceAfter',
        value: function getBalanceAfter() {
            return this.balance.balanceAfter;
        }

        /**
         * @return {number} rounds before
         */

    }, {
        key: 'getRoundsLeftBefore',
        value: function getRoundsLeftBefore() {
            return this.balance.roundsLeftBefore;
        }

        /**
         * @return {number} rounds after
         */

    }, {
        key: 'getRoundsLeftAfter',
        value: function getRoundsLeftAfter() {
            return this.balance.roundsLeftAfter;
        }

        /**
         * @typedef EndBet
         * @type {object}
         * @property {string} ticketId - The id of the ticket
         * @property {number} winAmount - the total amount won this round
         * @property {number} balanceAfter - new balance
         * @property {number} roundsLeft - new amount of tickets left
         */

        /**
         * Prepares the data object for the EndBet call
         * @return {EndBet} Data needed for Pariplay.Bet.endBet()
         */

    }, {
        key: 'getEndBetData',
        value: function getEndBetData() {
            var data = {
                ticketId: this.getTicketId(),
                totalWinAmount: this.getTotalWinAmount(),
                balanceAfter: this.getBalanceAfter(),
                roundsLeftAfter: this.getRoundsLeftAfter()
            };

            return data;
        }
    }]);

    return BetModel;
}(_baseModel2.default);

exports.default = BetModel;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _baseModel = __webpack_require__(0);

var _baseModel2 = _interopRequireDefault(_baseModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var TicketModel = function (_BaseModel) {
    _inherits(TicketModel, _BaseModel);

    /**
     * Initialise a model
     *
     * @param  {object} obj - Ticket data
     */
    function TicketModel(obj) {
        _classCallCheck(this, TicketModel);

        var _this = _possibleConstructorReturn(this, (TicketModel.__proto__ || Object.getPrototypeOf(TicketModel)).call(this));

        _this.name = 'TicketModel';

        _this.totalwinamount = 0;

        _this.keyMapping = {
            id: 'id',
            iswin: 'isWin',
            winindex: 'winIndex',
            winpossindex: 'winPossIndex',
            matrixindexes: 'matrixIndexes',
            totalbet: 'totalBet',
            totalwinamount: 'totalWinAmount'
        };

        _this.inject(obj);
        return _this;
    }

    return TicketModel;
}(_baseModel2.default);

exports.default = TicketModel;

/***/ })
/******/ ]);
});
//# sourceMappingURL=pariplay.js.map


/***/ })

});


// WEBPACK FOOTER //
// pp-ee010cd8bdbe317887e9.js